import script from "./TicketDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TicketDialog.vue?vue&type=style&index=0&id=4b4058a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4058a1"]])

export default __exports__